/** @format */
import { NextRouter } from 'next/router';

import { getLocalizedPath } from '@toucan/client/global/nextjs';

import { OAUTH_ERROR_PARAM } from '../config/constants';

export const removeOAuthErrorFromUrl = (
    router: NextRouter
): Promise<boolean> => {
    const query = { ...router.query };
    delete query[OAUTH_ERROR_PARAM];

    const searchParams = new URLSearchParams(router.asPath.split('?')[1]);
    searchParams.delete(OAUTH_ERROR_PARAM);
    const search = searchParams.toString();
    const searchSuffix = search ? `?${search}` : '';

    return router.replace(
        { pathname: router.pathname, query },
        `${getLocalizedPath(router)}${searchSuffix}`,
        { shallow: true, scroll: false }
    );
};
